<template>
  <div class="pdf-thumbnail-container">
    <div v-if="thumbnails.length === 0">No PDFs available.</div>
    <div v-else class="pdf-scroll-container">
      <div class="pdf-container">
        <!-- Iterate over the URLs and display each PDF thumbnail -->
        <img
          v-for="(thumbnail, index) in thumbnails"
          :key="index"
          :src="thumbnail"
          alt="PDF thumbnail"
          class="pdf-thumbnail"
          @click="openPdf(urls[index])"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist/webpack';
import 'pdfjs-dist/web/pdf_viewer.css';

export default {
  name: 'ArrayPdfThumbnail',
  props: {
    projectPath: {
      type: String,
      required: true
    },
    urls: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      thumbnails: [],
    };
  },
  computed: {
    urlsWithHttp() {
      return this.urls.map(url => `https://res.cloudinary.com/alvin-tan/image/upload/${this.projectPath}/${url}`);
    },
  },
  methods: {
    async generateThumbnail(url) {
      const loadingTask = pdfjsLib.getDocument(url);
      const pdf = await loadingTask.promise;
      const page = await pdf.getPage(1); // Get the first page
      const viewport = page.getViewport({ scale: 1.0 });
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      };
      await page.render(renderContext).promise;
      return canvas.toDataURL('image/png');
    },
    async loadThumbnails() {
      for (const url of this.urlsWithHttp) {
        const thumbnail = await this.generateThumbnail(url);
        this.thumbnails.push(thumbnail);
      }
    },
    openPdf(url) {
      window.open(url, '_blank');
    },
  },
  async mounted() {
    await this.loadThumbnails();
  },
};
</script>

<style>
.pdf-thumbnail-container {
  background-color: lightblue;
}

.pdf-scroll-container {
  overflow-x: auto;
  white-space: nowrap;
}

.pdf-container {
  display: inline-block;
}

.pdf-thumbnail {
  width: auto;
  height: 150px; /* Set a fixed height for the thumbnails */
  margin: 5px;
  cursor: pointer;
}
</style>
